import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { View, TouchableOpacity } from 'react-native'
import { ui } from '@linqpal/components'

import { styles } from './styles'

const { BtText } = ui

type PropTypes = {
  item: any
  setVisible: (visible: boolean) => void
  setItemToDelete: (id: string) => void
  isItInvoiceCreate?: boolean
}

export const SavedItems = memo((props: PropTypes) => {
  const { item, setVisible, setItemToDelete, isItInvoiceCreate } = props
  const { t } = useTranslation('global')
  return (
    <View style={styles.savedNotesContainer}>
      <BtText style={styles.savedNotesText} testID={`${item.message}_label`}>
        {item.message || item}
      </BtText>
      <View style={styles.breakLine} testID="breakLine" />
      <View style={styles.bottomContainer}>
        <BtText style={styles.date} testID="created_date_label">
          {item.createdDate}
        </BtText>
        <TouchableOpacity
          activeOpacity={0.6}
          onPress={() => {
            setVisible(true)
            if (isItInvoiceCreate) {
              setItemToDelete(item)
            } else {
              setItemToDelete(item?.id || item?._id)
            }
          }}
          testID="delete_note_button"
        >
          <BtText style={styles.deleteNote}>{t('InvoiceNotes.delete')}</BtText>
        </TouchableOpacity>
      </View>
    </View>
  )
})
